export default function HomePage() {
  return (
    <>
      <div className="text-center">
        <p>Bem-vindo(a) ao painel ABRA!</p>
        <p>Acesse a opção desejada no menu lateral.</p>
      </div>
    </>
  )
}
